<template>
  <!-- Add Fund prompt -->
  <vx-card>
    <vs-popup class="prompt" :active.sync="activeFundPrompt" :buttons-hidden="true">
      <div class="popup-parent">
        <p class="prompt-titles mb-3">Add Fund</p>
        <p class="prompt-body mb-8">
          Add fund to
          <b>{{account.name}}</b> using your available balance
        </p>
        <label class="prompt-label">Amount</label>
        <p class="prompt-hints mt-2">
        The amount must Equal to or less than your avaliable balance</p>
        <vs-input
          v-validate="'required|decimal:4|min:1|max:230'"
          placeholder="Amount"
          v-model="accountFund"
          name="Amount"
          class="w-full mt-2"
          type="text"
        ></vs-input>
        <span class="mt-3 mb-3 text-danger text-sm block">{{ errors.first('Amount') }}</span>
        <div class="flex flex-wrap mt-10 md:justify-end">
          <button
            class="md:ml-5 md:order-last add-fund-button"
            v-on:click="() => {
              addFund();
              activeFundPrompt=false;
            }"
          >Fund</button>
          <button
            class="pop-up-cancel-button"
            type="border"
            v-on:click="() => {
              clearFund();
              activeFundPrompt=false;
            }"
          >Cancel</button>
        </div>
      </div>
    </vs-popup>

    <vs-popup :active.sync="activeConfirmFundPrompt" :buttons-hidden="true">
      <div class="px-6 py-10 md:p-16">
        <img
          height="34"
          width="34"
          class="mr-5 float-left"
          src="@/assets/images/account-details/Question.svg"
        />
        <div class="md:flex md:flex-col">
          <p class="prompt-titles mb-5">Add Fund Confirmation</p>
          <p class="prompt-body">
            Are you sure you want to add
            <b>{{accountFund}}$</b> to
            <b>{{account.name}}'s</b>
            balance?
          </p>
        </div>
        <div class="flex flex-wrap mt-10 md:justify-end">
          <vs-button
            class="w-full mb-4 md:mb-0 md:w-1/3 md:ml-5 md:order-last primary-btns"
            @click="fundSubaccount"
          >Yes</vs-button>
          <vs-button
            class="w-full md:w-32 cancel-btns"
            type="border"
            @click="() => {
              activeConfirmFundPrompt=false;
              clearFund();
            }"
          >No</vs-button>
        </div>
      </div>
    </vs-popup>

    <vs-popup
      title="Success"
      @cancel="clearFund"
      :active.sync="activeSuccessPrompt"
      :buttons-hidden="true"
    >
      <div class="px-8 py-10 md:p-12 flex flex-col items-center">
        <img
          class="mb-10"
          width="100px"
          height="100px"
          src="@/assets/images/account-details/icons8-approval 1.svg"
        />
        <p class="confirm-box-body mb-6">
          Money has been added to
          <b>{{account.name}}'s</b> balance.
        </p>
        <vs-button v-on:click="activeSuccessPrompt=false" class="primary-btns w-full md:w-56">Ok</vs-button>
      </div>
    </vs-popup>
     <speakol-response-popup
      v-on:hide-response-popup="errorPopup.show = false"
      :responsePopupData="errorPopup"
    />

    <div class="flex flex-wrap">
      <!-- The account Info and avatar -->
      <div class="flex w-full justify-center md:justify-start items-center md:w-1/2">
        <div class="relative mr-8">
          <vs-avatar size="80px" :src="accountUrl" />
          <div :class="[account.blocked === 0 ? 'green-dot' : 'red-dot']"></div>
        </div>
        <div>
          <p class="account-name mb-2">{{ account.name }}</p>
          <div class="account-email mb-2">{{ account.email }}</div>
          <p class="account-status">
            status:
            <span :class="[account.blocked === 0 ? 'active-color' : 'blocked-color']">{{ accountStatusText }}</span>
          </p>
        </div>
      </div>

      <!-- The Fund and Block Button -->
      <div class="flex w-full flex-wrap md:flex-no-wrap md:justify-end mt-5 md:w-1/2">
        <vs-button
          class="w-full primary-btns md:mr-5 md:w-48"
          @click="activeFundPrompt=true"
          color="primary"
          icon-pack="speakol"
          icon="speakol-plus"
        >Add Fund</vs-button>

        <vs-button
          class="w-full mt-5 md:mt-0 md:w-40 cancel-btns"
          text-color="red"
          icon-pack="speakol"
          icon="speakol-block"
          type="border"
          @click="showConfirmationPopup=true">
          {{account.blocked === 1 ? 'Unblock' : 'Block'}}
        </vs-button>
      </div>
    </div>

    <speakol-response-popup
      v-on:hide-response-popup="responsePopupData.show = false"
      :responsePopupData="responsePopupData"
    />

    <speakol-confirmation-popup
      v-on:hide-confirmation-popup="showConfirmationPopup = false"
      v-on:confirm="block"
      :showConfirmationPopup="showConfirmationPopup"
      :title="'Confirmation'"
      :body="confirmationPopupBody"
    />
  </vx-card>
</template>


<script>
import { get } from 'lodash'

export default {
  data () {
    return {
      accountStatus: 'Active',
      accountFund: '',
      accountBalance: 200,
      activeFundPrompt: false,
      activeConfirmFundPrompt: false,
      activeSuccessPrompt: false,
      showConfirmationPopup: false,
      responsePopupData: {
        show: false
      },
      errorPopup: {
        type: 'error',
        show: false,
        body: ''
      }
    }
  },
  props: ['account'],
  computed: {
    confirmationPopupBody () {
      if (this.account.blocked === 0) {
        return `Are you sure you want to block ${this.account.name} ?`
      } else {
        return `Are you sure you want to unblock ${this.account.name} ?`
      }
    },

    accountStatusText () {
      if (this.account.blocked === 0) {
        return 'Active'
      } else {
        return 'Blocked'
      }
    },

    accountUrl () {
      return get(this.account, 'owner.0.media.0.url', '')
    }
  },

  methods: {
    async addFund () {
      await this.$validator.validate()
      if (this.errors.any()) {
        this.activeFundPrompt = true
      } else {
        this.activeConfirmFundPrompt = true
      }
    },

    async fundSubaccount () {
      try {
        this.activeConfirmFundPrompt = false

        await window.axios.post(
          `/accounts/subaccounts/${this.$route.params.id}/fund`,
          {
            amount: this.accountFund
          }
        )
        await this.$store.dispatch('fund/getBalance')
        this.clearFund()
        this.activeSuccessPrompt = true

      } catch (error) {
        // Handle error

        this.clearFund()
        this.errorPopup.body = error.response.data.message
        this.errorPopup.show = true
      }
    },

    clearFund () {
      this.$validator.reset()
      this.accountFund = ''
    },

    block () {

      this.showConfirmationPopup = false

      window.axios.post(`/accounts/${this.$route.params.id}/block`)
        .then(res => {
          this.account.blocked = res.data.payload.blocked

          this.responsePopupData.show = true
          this.responsePopupData.type = 'success'
          this.responsePopupData.body = `You have successfully ${res.data.payload.blocked === 0 ? 'unblocked' : 'blocked'} ${res.data.payload.name}`
          this.$store.dispatch('settings/members')
        }).catch(() => {

          this.responsePopupData.show = true
          this.responsePopupData.type = 'error'
          this.responsePopupData.body = 'Something went wrong!'
        })

    }
  }
}
</script>

<style lang="scss" scoped>
$speakolBlue: #0092d7;
$speakolWhite: white;
$outlineNone: none;
$boxShadowNone: none;
$borderNone: none;

.account-name {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.107143px;
}

.account-email {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.107143px;
  color: #2c2c2c;
}

.account-status {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.107143px;
  color: rgba(44, 44, 44, 0.4);
}

.speakol-blue {
  color: $speakolBlue;
}

.status-dot {
  width: 18px;
  height: 18px;
  position: absolute;
  bottom: 10px;
  left: 65px;
  top: 63%;
  border-radius: 50%;
  border: 2px solid $speakolWhite;
}

.green-dot {
  @extend .status-dot;

  background: #2dcd7a;
}

.red-dot {
  @extend .status-dot;

  background: red;
}

.active-color {
  color: #2dcd7a;
}

.blocked-color {
  color: red;
}

.w-200 {
  width: 200px;
}

.w-600px {
  width: 600px;
}

.btns {
  height: 48px !important;
  box-sizing: border-box;
  border-radius: 3px;
}

.primary-btns {
  @extend .btns;

  background: $speakolBlue;
}

.danger-btns {
  height: 48px;
  background: #fff;
  border: 2px solid #dadada;
  box-sizing: border-box;
  border-radius: 3px;
  color: #db2828;
}

.cancel-btns {
  @extend .btns;

  background: #fff;
  border: 2px solid #d9d9d9;
  color: rgba(0, 0, 0, 0.65) !important;
}

.prompt-titles {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0.1px;
  color: #2c2c2c;
}

.prompt-body {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: rgba(0, 0, 0, 0.56);
}

.prompt-labels {
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: #2c2c2c;
}

.confirm-box-body {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  letter-spacing: 0.1px;
  color: #2c2c2c;
}

.prompt-hints {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  display: flex;
  align-items: center;
  color: $speakolBlue;
}

.add-fund-button {
  background-color: $speakolBlue;
  color: $speakolWhite;
  width: 185px !important;
  height: 40px;
  cursor: pointer;
  outline: $outlineNone;
  border: $borderNone;
  box-shadow: $boxShadowNone;
  border-radius: 3px;
  font-weight: 500 !important;
}

.pop-up-cancel-button {
  background-color: $speakolWhite;
  color: black;
  font-weight: 500 !important;
  cursor: pointer;
  outline: $outlineNone;
  box-shadow: $boxShadowNone;
  width: 135px !important;
  height: 40px;
  border: 2px solid #d9d9d9;
  border-radius: 3px;
}

.popup-parent {
  padding: 37px 37px 37px 42px;
}

@media (max-width: 768px) {
  .add-fund-button {
    width: 100% !important;
    height: 40px;
    margin-bottom: 20px;
  }

  .pop-up-cancel-button {
    width: 100% !important;
    height: 40px;
  }

  .popup-parent {
    padding: 20px;
  }
}

</style>
